import React from "react";
import {
  Table,
  Stack,
  TableRow,
  TableBody,
  Typography,
  TableHead,
  TableSortLabel,
  Box,
  MenuItem,
  IconButton,
  Pagination,
  Grid,
  FormControl,
  InputLabel,
  Select,
  styled,
  Menu,
  Link,
  Popover,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import Card from "@mui/material/Card";
import Paper from "@mui/material/Paper";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import config from "../config";
import i18n from "../i18n";
import Iconify from "../components/iconify/Iconify";
import CircularProgress from "@mui/material/CircularProgress";
import moment from "moment";
import { useNavigate, useParams } from "react-router-dom";
import ScrollContainer from "react-indiana-drag-scroll";
import {
  deleteDocumentation,
  getDocumentations,
} from "../services/documentation.service";
import Swal from "sweetalert2";
import { convertMessageCodeToMessage } from "src/utils/messageCodeToMessage";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    border: '1px solid rgba(224, 224, 224, 1)'
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const tableHeaders = [
  {
    id: "wildlife_management_concept",
    label: i18n.t("wildlife_management_concept"),
    alignRight: false,
    sortable: true,
  },
  {
    id: "manira_airport",
    label: i18n.t("manira_airport"),
    alignRight: false,
    sortable: true,
  },
  {
    id: "airport_environment_management_plan",
    label: i18n.t("airport_environment_management_plan"),
    alignRight: false,
    sortable: true,
  },
  {
    id: "rci_rco",
    label: i18n.t("rci_rco"),
    alignCenter: true,
    sortable: true,
  },
  {
    id: "emergency_plan",
    label: i18n.t("emergency_plan"),
    alignCenter: true,
    sortable: true,
  },
  {
    id: "crisis_management_guide",
    label: i18n.t("crisis_management_guide"),
    alignCenter: true,
    sortable: true,
  },
  {
    id: "intervention_sheets",
    label: i18n.t("intervention_sheets"),
    alignCenter: true,
    sortable: true,
  },
  {
    id: "aerodrome_manual",
    label: i18n.t("aerodrome_manual"),
    alignRight: false,
    sortable: true,
  },
  { id: "" },
];
const tableHeaders2 = [
  {
    id: "initial_date",
    label: i18n.t("initial_date"),
    alignRight: false,
    sortable: true,
  },
  {
    id: "last_revision_date",
    label: i18n.t("last_revision_date"),
    alignRight: false,
    sortable: true,
  },
  {
    id: "initial_date",
    label: i18n.t("initial_date"),
    alignRight: false,
    sortable: true,
  },
  {
    id: "last_revision_date",
    label: i18n.t("last_revision_date"),
    alignRight: false,
    sortable: true,
  },
  {
    id: "initial_date",
    label: i18n.t("initial_date"),
    alignRight: false,
    sortable: true,
  },
  {
    id: "last_revision_date",
    label: i18n.t("last_revision_date"),
    alignRight: false,
    sortable: true,
  },
  {
    id: "initial_date",
    label: i18n.t("initial_date"),
    alignRight: false,
    sortable: true,
  },
  {
    id: "last_revision_date",
    label: i18n.t("last_revision_date"),
    alignRight: false,
    sortable: true,
  },
  {
    id: "initial_date",
    label: i18n.t("initial_date"),
    alignRight: false,
    sortable: true,
  },
  {
    id: "last_revision_date",
    label: i18n.t("last_revision_date"),
    alignRight: false,
    sortable: true,
  },
  {
    id: "initial_date",
    label: i18n.t("initial_date"),
    alignRight: false,
    sortable: true,
  },
  {
    id: "last_revision_date",
    label: i18n.t("last_revision_date"),
    alignRight: false,
    sortable: true,
  },
  {
    id: "initial_date",
    label: i18n.t("initial_date"),
    alignRight: false,
    sortable: true,
  },
  {
    id: "last_revision_date",
    label: i18n.t("last_revision_date"),
    alignRight: false,
    sortable: true,
  },
  {
    id: "initial_date",
    label: i18n.t("initial_date"),
    alignRight: false,
    sortable: true,
  },
  {
    id: "last_revision_date",
    label: i18n.t("last_revision_date"),
    alignRight: false,
    sortable: true,
  },
  { id: "" },
];

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
  "&:nth-of-type(odd):hover": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:nth-of-type(even):hover": {
    backgroundColor: "white",
  },
}));

const visuallyHidden = {
  border: 0,
  margin: -1,
  padding: 0,
  width: "1px",
  height: "1px",
  overflow: "hidden",
  position: "absolute",
  whiteSpace: "nowrap",
  clip: "rect(0 0 0 0)",
};
class DocumentationCombinedBteeSaTable extends React.Component {
  constructor(props) {
    super(props);
    this.airportId = props?.airportId;
    this.tableLimitOptions = config?.tableLimitOptions;
    this.tableLimitOptions = config?.tableLimitOptions;
    this.respOptions = config?.respOptions;
    this.confirmOptions = config?.confirmOptions;
    this.state = {
      documentations: [],
      documentation: {},
      open: null,
      page: 1,
      filtersOptions: [],
      search: "",
      limit: 25,
      skip: 0,
      total_documentations: 0,
      expanded: false,
      tableLoader: false,
      pageLoader: false,
      filters: {},
      orderBy: { sort_key: "airport", sort_order: true },
      deleteDocumentationPopup: false,
      showRespDropDown: false,
      showExecutedDropDown: false,
    };
    this.useStyles = {
      sticky: {
        position: "sticky",
        left: "0",
        zIndex: "5",
      },
    };
    this.enableEditOption = config?.enableEditOptionRenewal;
  }

  setStateAsync(state) {
    return new Promise((resolve) => {
      this.setState(state, resolve);
    });
  }

  componentDidMount() {
    this.getDocumentationsData();
  }


  handleDocumentationTableAction = async (
    action,
    data,
    rowData,
    key,
    rowIndex
  ) => {
    if (action === "pagination") {
      await this.setState({
        skip: (data - 1) * this.state?.limit,
        page: data,
      });
      this.getDocumentationsData();
    } else if (action === "limit") {
      await this.setState({
        limit: data,
      });
      this.getDocumentationsData();
    } else if (action === "popOverAction") {
      this.setState({
        documentationData: rowData,
        open: data?.target,
      });
    } else if (action === "sort") {
      /**These keys are inside airport key from BE,
       * the sort key for these are like : airport.[keyName]
       */
      if (config?.airportJsonKeys.includes(data.toLowerCase())) {
        await this.setState({
          orderBy: {
            sort_key:
              data === "airport"
                ? `airport_name`
                : `airport_${data.toLowerCase()}`,
            sort_order: !this.state?.orderBy?.sort_order,
          },
        });
      } else {
        await this.setState({
          orderBy: {
            sort_key: data,
            sort_order: !this.state?.orderBy?.sort_order,
          },
        });
      }
      this.getDocumentationsData();
    } else if (action === "closeMenu") {
      this.setState({
        open: null
      });
    } else if (action === "deleteDocumentation") {
      await this.setState({
        deleteDocumentationPopup: true,
        open: null,
      });
    } else if (action === "closeConfirmationPopUp") {
      this.setState({
        deleteDocumentationPopup: false,
      });
    } else if (action === "proceed") {
      this.setState({
        deleteDocumentationPopup: false,
      });
      this.handleDeleteDocumentation(
        this.state?.documentationData._id
      );
    }
  };

  async getDocumentationsData(action) {
    this.setStateAsync({
      tableLoader: true,
    });

    let query = {
      limit: this.state.limit,
      skip: this.state.skip,
      sort_key: this.state?.orderBy?.sort_key,
      sort_order: this.state?.orderBy?.sort_order
        ? "ASC"
        : "DESC",
    };

    if (this.airportId) {
      query["airport"] = this.airportId;
    }

    let documentations = await getDocumentations(query);
    if (documentations.error) {
      Swal.fire({
        icon: "error",
        title: i18n.t("error"),
        text: documentations?.error?.error_code
          ? i18n.t(convertMessageCodeToMessage(documentations?.error_code))
          : documentations?.error,
        confirmButtonText: i18n.t("ok"),
        confirmButtonColor: config.primaryColor,
      });
      this.setStateAsync({
        tableLoader: false,
      });
      return;
    }

    this.setStateAsync({
      tableLoader: false,
      documentations: documentations.documentations,
      total_documentations: documentations.count,
    });
  }
  async handleDeleteDocumentation(documentationId) {
    this.setStateAsync({
      pageLoader: true,
    });
    let response = await deleteDocumentation(documentationId);

    if (response && response.error) {
      Swal.fire({
        icon: "error",
        title: i18n.t("error"),
        text: response?.error?.error_code
          ? i18n.t(convertMessageCodeToMessage(response?.error_code))
          : response?.error,
      });
      return;
    }

    if (response) {
      Swal.fire({
        toast: true,
        position: "bottom-end",
        icon: "success",
        title: i18n.t("success"),
        text: response?.message_code
          ? i18n.t(convertMessageCodeToMessage(response?.message_code))
          : response?.message,
        showConfirmButton: false,
        timer: config.toastDelay,
        timerProgressBar: true,
      });
      await this.getDocumentationsData();
      this.setStateAsync({
        pageLoader: false,
      });
    }
  }
  handleClick = (event, data, rowIndex, key) => {
    this.setState({
      [key]: event.currentTarget,
      documentationData: data,
      rowIndex,
    });
  };
  handleClose = (key) => {
    this.setState({
      [key]: null,
    });
  };
  applyHeaderStyles = (headCell, index, data) => {
    let styles = {};
    if (["airport"].includes(headCell.id)) {
      styles = { ...this.useStyles?.sticky, ...styles }
    }
    if (index === data?.length - 2) {
      styles['borderRight'] = 'none'
    }
    if (index === data?.length - 1) {
      styles['borderLeft'] = 'none'
    }
    return styles;
  }

  render() {
    return (
      <>
        <Stack
          direction="row"
          sx={{
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
            mt:2
          }}
        >
          {(this.props?.showTitle) ? (
            <Typography variant="h4">
              {i18n.t("documentation_btee_sa")}
            </Typography>
          ) : null}

          {(this.props?.showAdd) ? (
            <Button
              variant="contained"
              startIcon={<Iconify icon="eva:plus-fill" />}
              className="BtnWidth"
              onClick={() => {
                this.props.navigate(
                  `/documentation-btee-sa/add?airport=${this.airportId}`
                );
              }}
            >
              {i18n.t("documentation")}
            </Button>
          ) : null}
        </Stack>
        <Card
          style={{
            boxShadow: "0 3px 10px rgb(0 0 0 / 0.2)",
            borderRadius: "5px",
          }}
        >
          <Paper sx={{ width: "100%", overflow: "hidden" }}>
            <ScrollContainer
              style={{ width: "100%", maxHeight: "calc(100vh - 255px)" }}
              hideScrollbars={false}
            >
              <Table stickyHeader size="small" aria-label="customized table">
                <TableHead>
                  <TableRow>
                    {/* {this.tableHeaders?.map((headCell) => (
                      <StyledTableCell
                        style={
                          ["airport"].includes(headCell.id)
                            ? this.useStyles?.sticky
                            : {}
                        }
                        align={ headCell.alignCenter
                          ? "center"
                          : headCell.alignRight
                          ? "right"
                          : "left"}
                        key={headCell.id}
                      >
                        {headCell.sortable ? (
                          <TableSortLabel
                            direction={
                              this.state?.orderBy?.sort_order ? "asc" : "desc"
                            }
                            onClick={async (e) => {
                              this.handleDocumentationTableAction("sort", headCell.id);
                            }}
                            style={{ color: "white" }}
                            hideSortIcon={headCell.sortable ? false : true}
                            active={
                              this.state?.orderBy.sort_key === headCell.id
                            }
                          >
                            {headCell.label}
                            {this.state?.orderBy?.sort_key === headCell.id &&
                            headCell.sortable ? (
                              <Box sx={{ ...visuallyHidden }}>
                                {this.state?.orderBy?.sort_order === "desc"
                                  ? "sorted descending"
                                  : "sorted ascending"}
                              </Box>
                            ) : null}
                          </TableSortLabel>
                        ) : (
                          <Typography variant="subtitle2">
                            {headCell.label}
                          </Typography>
                        )}
                      </StyledTableCell>
                    ))} */}
                    <StyledTableCell
                      align="center"
                      style={this.useStyles?.sticky}
                      rowSpan={3}
                    >
                      {i18n.t("airport")}
                    </StyledTableCell>
                    <StyledTableCell align="center" colSpan={8}>
                      {i18n.t("animal_risk")}
                    </StyledTableCell>
                    <StyledTableCell align="center" colSpan={6}>
                      {i18n.t("crisis_management")}
                    </StyledTableCell>
                    <StyledTableCell style={{ borderRight: 'none' }} align="center" colSpan={2}>
                      {i18n.t("safety_management_system")}
                    </StyledTableCell>
                    <StyledTableCell style={{ borderLeft: 'none' }} align="center"></StyledTableCell>
                  </TableRow>
                  <TableRow>
                    {tableHeaders?.map((headCell, index) => {
                      return (
                        <StyledTableCell
                          colSpan={headCell?.label !== "" && 2}
                          sx={{ textAlign: "center", border: index === this.tableHeaders?.length - 2 ? 'none' : index === this.tableHeaders?.length - 1 && '1px solid rgba(224, 224, 224, 1)' }}
                          style={
                            this.applyHeaderStyles(headCell, index, this.tableHeaders)
                          }
                        >
                          {i18n.t(headCell?.label)}
                        </StyledTableCell>
                      );
                    })}
                  </TableRow>
                  <TableRow>
                    {tableHeaders2?.map((headCell, index) => {
                      return (
                        <StyledTableCell
                          sx={{ minWidth: "150px" }}
                          style={
                            this.applyHeaderStyles(headCell, index, this.tableHeaders2)
                          }
                        >
                          {i18n.t(headCell?.label)}
                        </StyledTableCell>
                      );
                    })}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {!this.state?.tableLoader &&
                    this?.state?.documentations &&
                    this?.state?.documentations.map((row, index) => {
                      const {
                        _id,
                        airport,
                        animal_risk,
                        crisis_management,
                        safety_management_system,
                      } = row;

                      return (
                        <StyledTableRow
                          hover
                          key={_id}
                          tabIndex={-1}
                          onClick={() => {
                            this.handleDocumentationTableAction(_id);
                          }}
                        >
                          {(
                            <StyledTableCell
                              component="th"
                              scope="row"
                              style={{
                                position: "sticky",
                                left: 0,
                                background: "primary.light",
                                backgroundColor:
                                  index % 2 ? "white" : "#F6F7F8",
                                minWidth: "10rem",
                                borderRight: '1px solid black'
                              }}
                            >
                              <Stack
                                direction="row"
                                alignItems="center"
                                spacing={6}
                              >
                                <Stack
                                  direction="column"
                                  spacing={0}
                                  sx={{
                                    typography: "body2",
                                    cursor: "pointer",
                                  }}
                                  onDoubleClick={() => {
                                    this.airportId
                                      ? this.props.navigate(
                                        `/documentation-btee-sa/${_id}?airport=${this?.airportId}`
                                      )
                                      : this.props.navigate(`/documentation-btee-sa/${_id}`);
                                  }}
                                >
                                  <Typography variant="subtitle2">
                                    <Link
                                      onClick={() => {
                                        this.props.navigate(
                                          `/airports/airportDetails/${row?.airport?._id}`
                                        );
                                      }}
                                    >
                                      {airport?.name}
                                    </Link>
                                  </Typography>
                                </Stack>
                              </Stack>
                            </StyledTableCell>
                          )}

                          <StyledTableCell
                            align="left"
                            style={{ cursor: "pointer" }}
                            onDoubleClick={() => {
                              this.airportId
                                ? this.props.navigate(
                                  `/documentation-btee-sa/${_id}?airport=${this?.airportId}`
                                )
                                : this.props.navigate(`/documentation-btee-sa/${_id}`);
                            }}
                          >
                            <Stack
                              direction="row"
                              alignItems="centre"
                              spacing={2}
                              key={
                                animal_risk?.wildlife_management_concept
                                  ?.initial_date
                              }
                            >
                              <Stack
                                direction="column"
                                spacing={0}
                                sx={{ typography: "body2" }}
                              >
                                <Typography variant="subtitle2">
                                  {animal_risk?.wildlife_management_concept
                                    ?.initial_date ? moment(
                                      animal_risk?.wildlife_management_concept
                                        ?.initial_date
                                    ).format(i18n.t("OPTIONS.date_format")) : "-"}
                                </Typography>
                              </Stack>
                            </Stack>
                          </StyledTableCell>
                          <StyledTableCell
                            align="left"
                            style={{ cursor: "pointer", borderRight: '1px solid black' }}
                            onDoubleClick={() => {
                              this.airportId
                                ? this.props.navigate(
                                  `/documentation-btee-sa/${_id}?airport=${this?.airportId}`
                                )
                                : this.props.navigate(`/documentation-btee-sa/${_id}`);
                            }}
                          >
                            <Stack
                              direction="row"
                              alignItems="centre"
                              spacing={2}
                              key={
                                animal_risk?.wildlife_management_concept
                                  ?.last_revision_date
                              }
                            >
                              <Stack
                                direction="column"
                                spacing={0}
                                sx={{ typography: "body2" }}
                              >
                                <Typography variant="subtitle2">
                                  {animal_risk?.wildlife_management_concept
                                    ?.last_revision_date ? moment(
                                      animal_risk?.wildlife_management_concept
                                        ?.last_revision_date
                                    ).format(i18n.t("OPTIONS.date_format")) : "-"}
                                </Typography>
                              </Stack>
                            </Stack>
                          </StyledTableCell>

                          <StyledTableCell
                            align="left"
                            style={{ cursor: "pointer" }}
                            onDoubleClick={() => {
                              this.airportId
                                ? this.props.navigate(
                                  `/documentation-btee-sa/${_id}?airport=${this?.airportId}`
                                )
                                : this.props.navigate(`/documentation-btee-sa/${_id}`);
                            }}
                          >
                            <Stack
                              direction="row"
                              alignItems="centre"
                              spacing={2}
                              key={animal_risk?.manira_airport?.initial_date}
                            >
                              <Stack
                                direction="column"
                                spacing={0}
                                sx={{ typography: "body2" }}
                              >
                                <Typography variant="subtitle2">
                                  {animal_risk?.manira_airport?.initial_date ? moment(
                                    animal_risk?.manira_airport?.initial_date
                                  ).format(i18n.t("OPTIONS.date_format")) : "-"}
                                </Typography>
                              </Stack>
                            </Stack>
                          </StyledTableCell>
                          <StyledTableCell
                            align="left"
                            style={{ cursor: "pointer", borderRight: '1px solid black' }}
                            onDoubleClick={() => {
                              this.airportId
                                ? this.props.navigate(
                                  `/documentation-btee-sa/${_id}?airport=${this?.airportId}`
                                )
                                : this.props.navigate(`/documentation-btee-sa/${_id}`);
                            }}
                          >
                            <Stack
                              direction="row"
                              alignItems="centre"
                              spacing={2}
                              key={
                                animal_risk?.airport_environment_management_plan
                                  ?.last_revision_date
                              }
                            >
                              <Stack
                                direction="column"
                                spacing={0}
                                sx={{ typography: "body2" }}
                              >
                                <Typography variant="subtitle2">
                                  {animal_risk
                                    ?.airport_environment_management_plan
                                    ?.last_revision_date ? moment(
                                      animal_risk
                                        ?.airport_environment_management_plan
                                        ?.last_revision_date
                                    ).format(i18n.t("OPTIONS.date_format")) : '-'}
                                </Typography>
                              </Stack>
                            </Stack>
                          </StyledTableCell>

                          <StyledTableCell
                            align="left"
                            style={{ cursor: "pointer" }}
                            onDoubleClick={() => {
                              this.airportId
                                ? this.props.navigate(
                                  `/documentation-btee-sa/${_id}?airport=${this?.airportId}`
                                )
                                : this.props.navigate(`/documentation-btee-sa/${_id}`);
                            }}
                          >
                            <Stack
                              direction="row"
                              alignItems="centre"
                              spacing={2}
                              key={
                                animal_risk?.airport_environment_management_plan
                                  ?.initial_date
                              }
                            >
                              <Stack
                                direction="column"
                                spacing={0}
                                sx={{ typography: "body2" }}
                              >
                                <Typography variant="subtitle2">
                                  {animal_risk
                                    ?.airport_environment_management_plan
                                    ?.initial_date ? moment(
                                      animal_risk
                                        ?.airport_environment_management_plan
                                        ?.initial_date
                                    ).format(i18n.t("OPTIONS.date_format")) : '-'}
                                </Typography>
                              </Stack>
                            </Stack>
                          </StyledTableCell>
                          <StyledTableCell
                            align="left"
                            style={{ cursor: "pointer", borderRight: '1px solid black' }}
                            onDoubleClick={() => {
                              this.airportId
                                ? this.props.navigate(
                                  `/documentation-btee-sa/${_id}?airport=${this?.airportId}`
                                )
                                : this.props.navigate(`/documentation-btee-sa/${_id}`);
                            }}
                          >
                            <Stack
                              direction="row"
                              alignItems="centre"
                              spacing={2}
                              key={
                                animal_risk?.airport_environment_management_plan
                                  ?.last_revision_date
                              }
                            >
                              <Stack
                                direction="column"
                                spacing={0}
                                sx={{ typography: "body2" }}
                              >
                                <Typography variant="subtitle2">
                                  {animal_risk
                                    ?.airport_environment_management_plan
                                    ?.last_revision_date ? moment(
                                      animal_risk
                                        ?.airport_environment_management_plan
                                        ?.last_revision_date
                                    ).format(i18n.t("OPTIONS.date_format")) : '-'}
                                </Typography>
                              </Stack>
                            </Stack>
                          </StyledTableCell>

                          <StyledTableCell
                            align="left"
                            style={{ cursor: "pointer" }}
                            onDoubleClick={() => {
                              this.airportId
                                ? this.props.navigate(
                                  `/documentation-btee-sa/${_id}?airport=${this?.airportId}`
                                )
                                : this.props.navigate(`/documentation-btee-sa/${_id}`);
                            }}
                          >
                            <Stack
                              direction="row"
                              alignItems="centre"
                              spacing={2}
                              key={animal_risk?.rci_rco?.initial_date}
                            >
                              <Stack
                                direction="column"
                                spacing={0}
                                sx={{ typography: "body2" }}
                              >
                                <Typography variant="subtitle2">
                                  {animal_risk?.rci_rco?.initial_date ? moment(
                                    animal_risk?.rci_rco?.initial_date
                                  ).format(i18n.t("OPTIONS.date_format")) : '-'}
                                </Typography>
                              </Stack>
                            </Stack>
                          </StyledTableCell>
                          <StyledTableCell
                            align="left"
                            style={{ cursor: "pointer", borderRight: '2px solid black' }}
                            onDoubleClick={() => {
                              this.airportId
                                ? this.props.navigate(
                                  `/documentation-btee-sa/${_id}?airport=${this?.airportId}`
                                )
                                : this.props.navigate(`/documentation-btee-sa/${_id}`);
                            }}
                          >
                            <Stack
                              direction="row"
                              alignItems="centre"
                              spacing={2}
                              key={animal_risk?.rci_rco?.last_revision_date}
                            >
                              <Stack
                                direction="column"
                                spacing={0}
                                sx={{ typography: "body2" }}
                              >
                                <Typography variant="subtitle2">
                                  {animal_risk?.rci_rco?.last_revision_date ? moment(
                                    animal_risk?.rci_rco?.last_revision_date
                                  ).format(i18n.t("OPTIONS.date_format")) : '-'}
                                </Typography>
                              </Stack>
                            </Stack>
                          </StyledTableCell>

                          <StyledTableCell
                            align="left"
                            style={{ cursor: "pointer" }}
                            onDoubleClick={() => {
                              this.airportId
                                ? this.props.navigate(
                                  `/documentation-btee-sa/${_id}?airport=${this?.airportId}`
                                )
                                : this.props.navigate(`/documentation-btee-sa/${_id}`);
                            }}
                          >
                            <Stack
                              direction="row"
                              alignItems="centre"
                              spacing={2}
                              key={
                                crisis_management?.emergency_plan?.initial_date
                              }
                            >
                              <Stack
                                direction="column"
                                spacing={0}
                                sx={{ typography: "body2" }}
                              >
                                <Typography variant="subtitle2">
                                  {crisis_management?.emergency_plan
                                    ?.initial_date ? moment(
                                      crisis_management?.emergency_plan
                                        ?.initial_date
                                    ).format(i18n.t("OPTIONS.date_format")) : '-'}
                                </Typography>
                              </Stack>
                            </Stack>
                          </StyledTableCell>
                          <StyledTableCell
                            align="left"
                            style={{ cursor: "pointer", borderRight: '1px solid black' }}
                            onDoubleClick={() => {
                              this.airportId
                                ? this.props.navigate(
                                  `/documentation-btee-sa/${_id}?airport=${this?.airportId}`
                                )
                                : this.props.navigate(`/documentation-btee-sa/${_id}`);
                            }}
                          >
                            <Stack
                              direction="row"
                              alignItems="centre"
                              spacing={2}
                              key={
                                crisis_management?.emergency_plan
                                  ?.last_revision_date
                              }
                            >
                              <Stack
                                direction="column"
                                spacing={0}
                                sx={{ typography: "body2" }}
                              >
                                <Typography variant="subtitle2">
                                  {crisis_management?.emergency_plan
                                    ?.last_revision_date ? moment(
                                      crisis_management?.emergency_plan
                                        ?.last_revision_date
                                    ).format(i18n.t("OPTIONS.date_format")) : '-'}
                                </Typography>
                              </Stack>
                            </Stack>
                          </StyledTableCell>

                          <StyledTableCell
                            align="left"
                            style={{ cursor: "pointer" }}
                            onDoubleClick={() => {
                              this.airportId
                                ? this.props.navigate(
                                  `/documentation-btee-sa/${_id}?airport=${this?.airportId}`
                                )
                                : this.props.navigate(`/documentation-btee-sa/${_id}`);
                            }}
                          >
                            <Stack
                              direction="row"
                              alignItems="centre"
                              spacing={2}
                              key={
                                crisis_management?.crisis_management_guide
                                  ?.initial_date
                              }
                            >
                              <Stack
                                direction="column"
                                spacing={0}
                                sx={{ typography: "body2" }}
                              >
                                <Typography variant="subtitle2">
                                  {crisis_management?.crisis_management_guide
                                    ?.initial_date ? moment(
                                      crisis_management?.crisis_management_guide
                                        ?.initial_date
                                    ).format(i18n.t("OPTIONS.date_format")) : '-'}
                                </Typography>
                              </Stack>
                            </Stack>
                          </StyledTableCell>
                          <StyledTableCell
                            align="left"
                            style={{ cursor: "pointer", borderRight: '1px solid black' }}
                            onDoubleClick={() => {
                              this.airportId
                                ? this.props.navigate(
                                  `/documentation-btee-sa/${_id}?airport=${this?.airportId}`
                                )
                                : this.props.navigate(`/documentation-btee-sa/${_id}`);
                            }}
                          >
                            <Stack
                              direction="row"
                              alignItems="centre"
                              spacing={2}
                              key={
                                crisis_management?.crisis_management_guide
                                  ?.last_revision_date
                              }
                            >
                              <Stack
                                direction="column"
                                spacing={0}
                                sx={{ typography: "body2" }}
                              >
                                <Typography variant="subtitle2">
                                  {crisis_management?.crisis_management_guide
                                    ?.last_revision_date ? moment(
                                      crisis_management?.crisis_management_guide
                                        ?.last_revision_date
                                    ).format(i18n.t("OPTIONS.date_format")) : '-'}
                                </Typography>
                              </Stack>
                            </Stack>
                          </StyledTableCell>

                          <StyledTableCell
                            align="left"
                            style={{ cursor: "pointer" }}
                            onDoubleClick={() => {
                              this.airportId
                                ? this.props.navigate(
                                  `/documentation-btee-sa/${_id}?airport=${this?.airportId}`
                                )
                                : this.props.navigate(`/documentation-btee-sa/${_id}`);
                            }}
                          >
                            <Stack
                              direction="row"
                              alignItems="centre"
                              spacing={2}
                              key={
                                crisis_management?.intervention_sheets
                                  ?.initial_date
                              }
                            >
                              <Stack
                                direction="column"
                                spacing={0}
                                sx={{ typography: "body2" }}
                              >
                                <Typography variant="subtitle2">
                                  {crisis_management?.intervention_sheets
                                    ?.initial_date ? moment(
                                      crisis_management?.intervention_sheets
                                        ?.initial_date
                                    ).format(i18n.t("OPTIONS.date_format")) : '-'}
                                </Typography>
                              </Stack>
                            </Stack>
                          </StyledTableCell>
                          <StyledTableCell
                            align="left"
                            style={{ cursor: "pointer", borderRight: '2px solid black' }}
                            onDoubleClick={() => {
                              this.airportId
                                ? this.props.navigate(
                                  `/documentation-btee-sa/${_id}?airport=${this?.airportId}`
                                )
                                : this.props.navigate(`/documentation-btee-sa/${_id}`);
                            }}
                          >
                            <Stack
                              direction="row"
                              alignItems="centre"
                              spacing={2}
                              key={
                                crisis_management?.intervention_sheets
                                  ?.last_revision_date
                              }
                            >
                              <Stack
                                direction="column"
                                spacing={0}
                                sx={{ typography: "body2" }}
                              >
                                <Typography variant="subtitle2">
                                  {crisis_management?.intervention_sheets
                                    ?.last_revision_date ? moment(
                                      crisis_management?.intervention_sheets
                                        ?.last_revision_date
                                    ).format(i18n.t("OPTIONS.date_format")) : '-'}
                                </Typography>
                              </Stack>
                            </Stack>
                          </StyledTableCell>

                          <StyledTableCell
                            align="left"
                            style={{ cursor: "pointer" }}
                            onDoubleClick={() => {
                              this.airportId
                                ? this.props.navigate(
                                  `/documentation-btee-sa/${_id}?airport=${this?.airportId}`
                                )
                                : this.props.navigate(`/documentation-btee-sa/${_id}`);
                            }}
                          >
                            <Stack
                              direction="row"
                              alignItems="centre"
                              spacing={2}
                              key={
                                safety_management_system?.aerodrome_manual
                                  ?.initial_date
                              }
                            >
                              <Stack
                                direction="column"
                                spacing={0}
                                sx={{ typography: "body2" }}
                              >
                                <Typography variant="subtitle2">
                                  {safety_management_system?.aerodrome_manual
                                    ?.initial_date ? moment(
                                      safety_management_system?.aerodrome_manual
                                        ?.initial_date
                                    ).format(i18n.t("OPTIONS.date_format")) : '-'}
                                </Typography>
                              </Stack>
                            </Stack>
                          </StyledTableCell>
                          <StyledTableCell
                            align="left"
                            style={{ cursor: "pointer" }}
                            onDoubleClick={() => {
                              this.airportId
                                ? this.props.navigate(
                                  `/documentation-btee-sa/${_id}?airport=${this?.airportId}`
                                )
                                : this.props.navigate(`/documentation-btee-sa/${_id}`);
                            }}
                          >
                            <Stack
                              direction="row"
                              alignItems="centre"
                              spacing={2}
                              key={
                                safety_management_system?.aerodrome_manual
                                  ?.last_revision_date
                              }
                            >
                              <Stack
                                direction="column"
                                spacing={0}
                                sx={{ typography: "body2" }}
                              >
                                <Typography variant="subtitle2">
                                  {safety_management_system?.aerodrome_manual
                                    ?.last_revision_date ? moment(
                                      safety_management_system?.aerodrome_manual
                                        ?.last_revision_date
                                    ).format(i18n.t("OPTIONS.date_format")) : '-'}
                                </Typography>
                              </Stack>
                            </Stack>
                          </StyledTableCell>

                          <StyledTableCell align="right">
                            <IconButton
                              size="large"
                              sx={{ padding: "2px" }}
                              color="inherit"
                              onClick={(e) => {
                                this.handleDocumentationTableAction("popOverAction", e, row);
                              }}
                            >
                              <Iconify icon={"eva:more-vertical-fill"} />
                            </IconButton>
                          </StyledTableCell>
                        </StyledTableRow>
                      );
                    })}
                  {this.state?.tableLoader && (
                    <TableRow>
                      <TableCell
                        style={{ textAlign: "center" }}
                        colSpan={"100%"}
                      >
                        <CircularProgress />
                      </TableCell>
                    </TableRow>
                  )}

                  {!this.state?.tableLoader &&
                    this?.state?.documentations?.length === 0 && (
                      <TableRow>
                        <TableCell
                          style={{ textAlign: "center" }}
                          colSpan={"100%"}
                        >
                          {i18n.t('no_records_found')}
                        </TableCell>
                      </TableRow>
                    )}
                </TableBody>
              </Table>
            </ScrollContainer>
          </Paper>
        </Card>

        {this.state.documentations?.length !== 0 && (
          <Grid
            container
            spacing={2}
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Grid></Grid>
            <Grid item>
              <Pagination
                count={Math.ceil(this.state.total_documentations / this.state.limit)}
                shape="rounded"
                size="large"
                onChange={async (event, page) => {
                  this.handleDocumentationTableAction("pagination", page);
                }}
                page={this.state.page}
                showFirstButton={true}
                showLastButton={true}
                boundaryCount={2}
                style={{ margin: 20 }}
              />
            </Grid>
            <Grid item style={{ width: "10%" }}>
              <FormControl fullWidth size="small">
                <InputLabel id="demo-simple-select-label">Limit</InputLabel>
                <Select
                  value={this.state.limit}
                  label="Limit"
                  size="small"
                  onChange={async (e) => {
                    this.handleDocumentationTableAction("limit", e?.target?.value);
                  }}
                >
                  {this.tableLimitOptions?.map((limit) => {
                    return (
                      <MenuItem value={limit?.value}>{limit?.label}</MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Grid>
            <Popover
              open={Boolean(this.state.open)}
              anchorEl={this.state.open}
              onClose={() => {
                this.handleDocumentationTableAction("closeMenu");
              }}
              anchorOrigin={{ vertical: "top", horizontal: "left" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
              PaperProps={{
                sx: {
                  p: 1,
                  width: 140,
                  "& .MuiMenuItem-root": {
                    px: 1,
                    typography: "body2",
                    borderRadius: 0.75,
                  },
                },
              }}
            >
              <MenuItem
                onClick={() => {
                  this.handleDocumentationTableAction("closeMenu");
                  this.airportId
                    ? this.props.navigate(
                      `/documentation-btee-sa/${this.state.documentationData._id}?airport=${this.airportId}`
                    )
                    : this.props.navigate("/documentation-btee-sa/" + this.state.documentationData._id);
                }}
              >
                <Iconify icon={"eva:edit-fill"} sx={{ mr: 2 }} />
                {i18n.t("edit")}
              </MenuItem>
              <MenuItem
                onClick={() => {
                  this.handleDocumentationTableAction("deleteDocumentation");
                }}
              >
                <Iconify icon={"ant-design:delete-filled"} sx={{ mr: 2 }} />
                {i18n.t("delete")}
              </MenuItem>
            </Popover>
            <Dialog
              open={this.state?.deleteDocumentationPopup}
              onClose={() => {
                this.handleDocumentationTableAction("closeConfirmationPopUp");
              }}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">{i18n.t("delete")}</DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  {i18n.t('are_you_sure_of_deleting_this_action_is_irreversible')}
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  variant="outlined"
                  onClick={() => {
                    this.handleDocumentationTableAction("closeConfirmationPopUp");
                  }}
                  autoFocus
                >
                  {i18n.t("cancel")}
                </Button>
                <Button
                  variant="contained"
                  onClick={async () => {
                    this.handleDocumentationTableAction("proceed");
                  }}
                >
                  {i18n.t("proceed")}
                </Button>
              </DialogActions>
            </Dialog>
          </Grid>
        )}
      </>
    );
  }
}
// Wrap and export
export default function (props) {
  const navigate = useNavigate();
  const params = useParams();

  return (
    <DocumentationCombinedBteeSaTable {...props} navigate={navigate} params={params} />
  );
}
